import currencyFormatter from 'currency-formatter';

export default function formatCents(cents, currency) {
  try {
    const parsed = parseInt(cents, 10);
    if (isNaN(parsed)) {
      return '';
    }
    const dollars = cents / 100;
    return currencyFormatter.format(dollars, { code: currency });
  } catch (ex) {
    return '';
  }
}
